// API konfiguráció
const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001') + '/api';

// Google Maps API Key
export const GOOGLE_MAPS_FRONTEND_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_FRONTEND_API_KEY; // ÚJ EXPORT

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    ACTIVATE: '/auth/activate',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    TEST: '/auth/test',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    RESEND_ACTIVATION: '/auth/resend-activation',
    PROVIDER_INVITE_CLAIM: '/auth/provider-invite/claim',
    EMAIL_CHANGE_CONFIRM: '/auth/email-change/confirm',
    PROVIDER_INVITE_DECLINE: '/auth/provider-invite/decline',
    PROVIDER_INVITE_DECLINE_INFO: (token) => `/auth/provider-invite/decline/${encodeURIComponent(token)}`,
    PROVIDER_INVITE_INFO: (token) => `/auth/provider-invite/${encodeURIComponent(token)}`,
    GOOGLE: '/auth/google',
    FACEBOOK: '/auth/facebook',
    SOCIAL_COMPLETE: '/auth/social-complete'
  },
  
  // Users - FRISSÍTETT
  USERS: {
    PROFILE: '/users/profile',
    PASSWORD: '/users/password',
    AVATAR: '/users/avatar',
    SETTINGS: '/users/settings',
    VERIFY_EMAIL: '/users/verify-email',
    RESEND_VERIFICATION: '/users/resend-verification',
    DELETE_ACCOUNT: '/users/account'
  },
  
  // Főoldal
  HOME: {
    DISCOVERY: '/home/discovery'
  },

  // Providers - FRISSÍTETT
  PROVIDERS: {
    LIST: '/providers',
    DETAIL: (id) => `/providers/${id}`,
    ME: '/providers/me',
    UPDATE: (id) => `/providers/${id}`,
    STATUS: (id) => `/providers/${id}/status`,
    STATS: '/providers/me/stats',
    REGISTER: '/providers/register',
    POPULAR: '/providers/popular',
    NEARBY: '/providers/nearby',
    AVAILABILITY: (id) => `/providers/${id}/availability`,
    BUSINESS_HOURS: (id) => `/providers/${id}/business-hours`
  },
  
  ADMIN: {
    STATS: '/admin/stats',
    PROVIDERS_PENDING: '/admin/providers/pending',
    PROVIDERS_APPROVED: '/admin/providers/approved',
    PROVIDERS_REJECTED: '/admin/providers/rejected',
    PROVIDERS_DRAFT: '/admin/providers/draft',
    PROVIDERS_DELETED: '/admin/providers/deleted',
    PROVIDERS_CREATE: '/admin/providers',
    PROVIDER_INVITE: (id) => `/admin/providers/${id}/invite`,
    PROVIDERS_INVITE_BULK: '/admin/providers/invite-bulk',
    EMAIL_TEMPLATES: '/admin/email-templates',
    EMAIL_TEMPLATE: (id) => `/admin/email-templates/${id}`,
    EMAIL_TEMPLATE_PREVIEW: '/admin/email-templates/preview',
    EMAIL_TEMPLATE_TEST: '/admin/email-templates/test',
    PROVIDER_IMPORTS: '/admin/provider-imports',
    PROVIDER_IMPORT_PREVIEW: '/admin/provider-imports/preview',
    PROVIDER_IMPORT: (id) => `/admin/provider-imports/${id}`,
    PROVIDER_IMPORT_PROVIDERS: (id) => `/admin/provider-imports/${id}/providers`,
    PROVIDER_STATUS: (id) => `/admin/providers/${id}/status`,
    PROVIDER_DETAIL: (id) => `/admin/providers/${id}`,
    REPORTED_CONTENT: '/admin/reports',
    USERS: '/admin/users',
    DELETE_USER: (id) => `/admin/users/${id}`,
    REACTIVATE_USER: (id) => `/admin/users/${id}/reactivate`,
    REACTIVATE_PROVIDER: (id) => `/admin/providers/${id}/reactivate`,
    REVIEW_STATUS: (id) => `/admin/reviews/${id}/status`,
    DELETE_PROVIDER: (id) => `/admin/providers/${id}`,
    BULK_EMAIL_TEMPLATES: '/admin/bulk-email/templates',
    BULK_EMAIL_RECIPIENTS: '/admin/bulk-email/recipients',
    BULK_EMAIL_RECIPIENTS_LIST: '/admin/bulk-email/recipients/list',
    BULK_EMAIL_PREVIEW: '/admin/bulk-email/preview',
    BULK_EMAIL_TEST: '/admin/bulk-email/test',
    BULK_EMAIL_SEND: '/admin/bulk-email/send',
    BULK_EMAIL_LOGS: '/admin/bulk-email/logs',
    ANALYTICS: {
      OVERVIEW_SUMMARY: '/admin/analytics/overview/summary',
      OVERVIEW_TIMESERIES: '/admin/analytics/overview/timeseries',
      BY_CATEGORY: '/admin/analytics/by-category',
      BY_COUNTY: '/admin/analytics/by-county',
      PROVIDERS_SEARCH: '/admin/analytics/providers/search',
      MARKETPLACE_KPIS: '/admin/analytics/marketplace-kpis',
    },
  },
  
  BOOKINGS: {
    LIST: '/bookings',
    CREATE: '/bookings', // Ez most már ajánlatkérés létrehozása
    DETAIL: (id) => `/bookings/${id}`,
    UPDATE: (id) => `/bookings/${id}`, // Általános frissítés (admin/provider)
    DELETE: (id) => `/bookings/${id}`,
    STATUS: (id) => `/bookings/${id}/status`, // Általános státusz frissítés (pl. COMPLETED, CANCELLED)
    
    // ÚJ AJÁNLATKÉRÉS/AJÁNLAT FLOW VÉGPONTOK
    SEND_OFFER: (bookingId) => `/bookings/${bookingId}/send-offer`,
    ACCEPT_OFFER: (bookingId) => `/bookings/${bookingId}/accept-offer`,
    REJECT_OFFER: (bookingId) => `/bookings/${bookingId}/reject-offer`,
    REQUEST_NEW_OFFER: (bookingId) => `/bookings/${bookingId}/request-new-offer`,
    
    AVAILABLE_SLOTS: (providerId) => `/bookings/providers/${providerId}/available-slots`,
    CONFIRM_PAYMENT: (bookingId) => `/bookings/${bookingId}/confirm-payment`,
  },

  PAYMENTS: {
    INITIATE: '/payments/initiate',
    INITIATE_OFFLINE: '/payments/initiate-offline',
    STATUS: (paymentId) => `/payments/status/${paymentId}`,
    FEATURED_INITIATE: '/payments/featured/initiate',
  },
  
  // Reviews
  REVIEWS: {
    LIST: '/reviews',
    CREATE: '/reviews',
    DETAIL: (id) => `/reviews/${id}`,
    UPDATE: (id) => `/reviews/${id}`,
    STATUS: (id) => `/reviews/${id}/status`,
    REPLY: (id) => `/reviews/${id}/reply`,
    MY: '/reviews/my'
  },
  
  // Categories - FRISSÍTETT
  CATEGORIES: {
    LIST: '/categories',
    CREATE: '/categories',
    DETAIL: (id) => `/categories/${id}`,
    UPDATE: (id) => `/categories/${id}`,
    DELETE: (id) => `/categories/${id}`,
    ACTIVE: '/categories?active=true',
    WITH_SEO: '/categories?includeSeo=1',
    SEO_CONTENT: (slug) => `/categories/slug/${encodeURIComponent(slug)}/seo-content`,
    UPDATE_SEO_CONTENT: (id) => `/categories/${id}/seo-content`,
    PROVIDERS: (id) => `/categories/${id}/providers`
  },
  
  // Favorites - FRISSÍTETT
  FAVORITES: {
    LIST: '/favorites',
    ADD: '/favorites',
    REMOVE: (providerId) => `/favorites/${providerId}`,
    CHECK: (providerId) => `/favorites/check/${providerId}`,
    TOGGLE: '/favorites/toggle'
  },
  
  MESSAGES: { // ÚJ
    LIST: '/messages',
    SEND: '/messages',
    MARK_READ: (id) => `/messages/${id}/read`,
    CONVERSATION: (participantId) => `/messages/conversation/${participantId}`,
    UNREAD_COUNT: '/messages/unread-count', // ÚJ
    MARK_UNREAD: (id) => `/messages/${id}/unread`, // ÚJ (backend végpont szükséges)
    DELETE: (id) => `/messages/${id}`, // ÚJ (backend végpont szükséges)
    MARK_MULTIPLE_READ: '/messages/read-multiple', // ÚJ (backend végpont szükséges)
    MARK_MULTIPLE_UNREAD: '/messages/unread-multiple', // ÚJ (backend végpont szükséges)
    DELETE_MULTIPLE: '/messages/delete-multiple', // ÚJ (backend végpont szükséges)
  },


  // Notifications - FRISSÍTETT
  NOTIFICATIONS: {
    BASE: '/notifications', // LIST helyett BASE
    UNREAD_COUNT: '/notifications/unread-count',
    CONVERSATION: (participantId) => `/messages/conversation/${participantId}`,
    MARK_AS_READ: (id) => `/notifications/${id}/read`,
    MARK_AS_UNREAD: (id) => `/notifications/${id}/unread`, // ÚJ
    MARK_ALL_AS_READ: '/notifications/read-all',
    DELETE: (id) => `/notifications/${id}`,
    MARK_MULTIPLE_AS_READ: '/notifications/multiple/read', // ÚJ
    MARK_MULTIPLE_AS_UNREAD: '/notifications/multiple/unread', // ÚJ
    DELETE_MULTIPLE: '/notifications/multiple', // ÚJ
  },
  
  // Dashboard - FRISSÍTETT
  DASHBOARD: {
    DATA: '/dashboard',
    RECENT_ACTIVITY: '/dashboard/recent-activity',
    CLIENT: '/dashboard/client',
    PROVIDER: '/dashboard/provider',
    ADMIN: '/dashboard/admin'
  },
  
  // Stats
  STATS: {
    PLATFORM: '/stats/platform',
    PROVIDER: (id) => `/stats/provider/${id}`,
    USER: '/stats/user'
  },


  // ==========================================
  // WEDDING PLANNER ENDPOINTS
  // ==========================================
  WEDDING_EVENTS: {
    // Main CRUD
    LIST: '/wedding-events',
    CREATE: '/wedding-events',
    DEMO_RESET: '/wedding-events/demo/reset',
    DETAIL: (id) => `/wedding-events/${id}`,
    UPDATE: (id) => `/wedding-events/${id}`,
    DELETE: (id) => `/wedding-events/${id}`,
    SUMMARY: (id) => `/wedding-events/${id}/summary`,
    
    // Categories
    CATEGORIES: (id) => `/wedding-events/${id}/categories`,
    ADD_CATEGORY: (id) => `/wedding-events/${id}/categories`,
    REMOVE_CATEGORY: (eventId, categoryId) => `/wedding-events/${eventId}/categories/${categoryId}`,
    
    // Guests
    GUESTS: (id) => `/wedding-events/${id}/guests`,
    ADD_GUEST: (id) => `/wedding-events/${id}/guests`,
    UPDATE_GUEST: (eventId, guestId) => `/wedding-events/${eventId}/guests/${guestId}`,
    DELETE_GUEST: (eventId, guestId) => `/wedding-events/${eventId}/guests/${guestId}`,
    IMPORT_GUESTS: (id) => `/wedding-events/${id}/guests/import`,
    
    // Budget
    BUDGET_SUMMARY: (id) => `/wedding-events/${id}/budget`,
    BUDGET_ITEMS: (id) => `/wedding-events/${id}/budget/items`,
    ADD_BUDGET_ITEM: (id) => `/wedding-events/${id}/budget/items`,
    UPDATE_BUDGET_ITEM: (eventId, itemId) => `/wedding-events/${eventId}/budget/items/${itemId}`,
    DELETE_BUDGET_ITEM: (eventId, itemId) => `/wedding-events/${eventId}/budget/items/${itemId}`,
    
    // Vendors (Marketplace + Custom)
    VENDORS: (id) => `/wedding-events/${id}/vendors`,
    ADD_CUSTOM_VENDOR: (id) => `/wedding-events/${id}/vendors/custom`,
    UPDATE_CUSTOM_VENDOR: (eventId, vendorId) => `/wedding-events/${eventId}/vendors/custom/${vendorId}`,
    DELETE_CUSTOM_VENDOR: (eventId, vendorId) => `/wedding-events/${eventId}/vendors/custom/${vendorId}`,

    // Vendor categories (event-specific, user-defined)
    VENDOR_CATEGORIES: (id) => `/wedding-events/${id}/vendor-categories`,
    ADD_VENDOR_CATEGORY: (id) => `/wedding-events/${id}/vendor-categories`,
    UPDATE_VENDOR_CATEGORY: (eventId, catId) => `/wedding-events/${eventId}/vendor-categories/${catId}`,
    DELETE_VENDOR_CATEGORY: (eventId, catId) => `/wedding-events/${eventId}/vendor-categories/${catId}`,
    ASSIGN_MARKETPLACE_VENDOR_CATEGORY: (eventId, budgetItemId) => `/wedding-events/${eventId}/vendors/marketplace/${budgetItemId}/category`,
    
    // Tasks
    TASKS: (id) => `/wedding-events/${id}/tasks`,
    ADD_TASK: (id) => `/wedding-events/${id}/tasks`,
    UPDATE_TASK: (eventId, taskId) => `/wedding-events/${eventId}/tasks/${taskId}`,
    TOGGLE_TASK: (eventId, taskId) => `/wedding-events/${eventId}/tasks/${taskId}/toggle`,
    DELETE_TASK: (eventId, taskId) => `/wedding-events/${eventId}/tasks/${taskId}`,
    
    // Timeline
    TIMELINE: (id) => `/wedding-events/${id}/timeline`,
    ADD_TIMELINE_EVENT: (id) => `/wedding-events/${id}/timeline`,
    UPDATE_TIMELINE_EVENT: (eventId, timelineEventId) => `/wedding-events/${eventId}/timeline/${timelineEventId}`,
    DELETE_TIMELINE_EVENT: (eventId, timelineEventId) => `/wedding-events/${eventId}/timeline/${timelineEventId}`,
    REORDER_TIMELINE: (id) => `/wedding-events/${id}/timeline/reorder`,
    
    // Seating
    SEATING_TABLES: (id) => `/wedding-events/${id}/seating/tables`,
    ADD_SEATING_TABLE: (id) => `/wedding-events/${id}/seating/tables`,
    UPDATE_SEATING_TABLE: (eventId, tableId) => `/wedding-events/${eventId}/seating/tables/${tableId}`,
    DELETE_SEATING_TABLE: (eventId, tableId) => `/wedding-events/${eventId}/seating/tables/${tableId}`,
    ASSIGN_GUEST_TO_TABLE: (eventId, guestId) => `/wedding-events/${eventId}/guests/${guestId}/assign-table`,
    UNASSIGN_GUEST_FROM_TABLE: (eventId, guestId) => `/wedding-events/${eventId}/guests/${guestId}/unassign-table`,
    SEATING_CHART: (id) => `/wedding-events/${id}/seating/chart`,
    SEATING_LAYOUT: (id) => `/wedding-events/${id}/seating/layout`,
    SAVE_SEATING_LAYOUT: (id) => `/wedding-events/${id}/seating/layout`,

    // Invitation
    INVITATION: (id) => `/wedding-events/${id}/invitation`,
    INVITATION_UPLOAD: (id) => `/wedding-events/${id}/invitation/upload`,
    INVITATION_SEND: (id) => `/wedding-events/${id}/invitation/send`,
    INVITATION_SEND_REMINDERS: (id) => `/wedding-events/${id}/invitation/send-reminders`,
    INVITATION_SEND_SINGLE: (eventId, guestId) => `/wedding-events/${eventId}/guests/${guestId}/send-invitation`,
  },

  // Publikus RSVP végpontok (token alapú, nincs auth)
  RSVP: {
    GET: (token) => `/rsvp/${token}`,
    SUBMIT: (token) => `/rsvp/${token}`,
  },

  // Meilisearch keresés
  SEARCH: {
    QUERY: '/search',
    AUTOCOMPLETE: '/search/autocomplete',
  },

  // ÚJ: User Pins
  USER_PINS: {
    LIST: '/user-pins',
    CREATE: '/user-pins',
    UPDATE: (id) => `/user-pins/${id}`,
    DELETE: (id) => `/user-pins/${id}`,
  },

  // ÚJ: Provider Calendar (foglalt napok, ICS szinkron)
  PROVIDER_CALENDAR: {
    BUSY_DATES: (providerId) => `/providers/${providerId}/calendar/busy-dates`,
    UPLOAD_ICS: (providerId) => `/providers/${providerId}/calendar/upload-ics`,
    ADD_BUSY_DATE: (providerId) => `/providers/${providerId}/calendar/busy-dates`,
    UPDATE_BUSY_DATE: (providerId, busyDateId) => `/providers/${providerId}/calendar/busy-dates/${busyDateId}`,
    REMOVE_BUSY_DATE: (providerId, busyDateId) => `/providers/${providerId}/calendar/busy-dates/${busyDateId}`,
  },

  PACKAGES: {
    BY_PROVIDER: (id) => `/packages/provider/${id}`,
    ALL_BY_PROVIDER: (id) => `/packages/provider/${id}/all`,
    CREATE: (id) => `/packages/provider/${id}`,
    UPDATE: (id) => `/packages/${id}`,
    DELETE: (id) => `/packages/${id}`,
    REORDER: (id) => `/packages/provider/${id}/reorder`,
  },

  BUG_REPORTS: {
    CREATE: '/bug-reports',
    ADMIN_LIST: '/admin/bug-reports',
    ADMIN_UPDATE: (id) => `/admin/bug-reports/${id}`,
  },

  LEGAL: {
    CURRENT: (type) => `/legal/current?type=${type}`,
    PENDING: '/legal/pending',
    ACCEPT: '/legal/accept',
    ADMIN_PUBLISH: (documentId) => `/admin/legal/${documentId}/publish`,
  },

  FORUM: {
    CATEGORIES: '/forum/categories',
    THREADS: '/forum/threads',
    THREAD: (id) => `/forum/threads/${id}`,
    THREAD_PIN: (id) => `/forum/threads/${id}/pin`,
    THREAD_LOCK: (id) => `/forum/threads/${id}/lock`,
    THREAD_HIDE: (id) => `/forum/threads/${id}/hide`,
    REPLIES: (threadId) => `/forum/threads/${threadId}/replies`,
    REPLY: (id) => `/forum/replies/${id}`,
    REPLY_HIDE: (id) => `/forum/replies/${id}/hide`,
    REPLY_EXPERT: (id) => `/forum/replies/${id}/expert`,
    REACT: '/forum/react',
    REPORT: '/forum/report',
    REPORTS: '/forum/reports',
    REPORT_STATUS: (id) => `/forum/reports/${id}/status`,
  }
};

// HTTP methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH'
};

// File upload limits
export const UPLOAD_LIMITS = {
  AVATAR_MAX_SIZE: 10 * 1024 * 1024, // 10MB
  IMAGE_MAX_SIZE: 10 * 1024 * 1024,  // 10MB
  MAX_PROVIDER_IMAGES: 10,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
};

// API response status codes
export const STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500
};

export default API_BASE_URL;